module.exports = __webpack_public_path__ + "static/media/workshopFire.d32ae153.svg";